if (!customElements.get('delivery-estimate')) {
  customElements.define(
    'delivery-estimate',
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.delivery-estimate__form');
        this.input = this.querySelector('.delivery-estimate__input');
        this.result = this.querySelector('.delivery-estimate__result');
        this.error = this.querySelector('.delivery-estimate__error');
        this.button = this.querySelector('.delivery-estimate__button');
        this.buttonLabel = this.querySelector('[data-delivery-button-label]');
        this.defaultButtonLabel = this.buttonLabel?.textContent;
        this.form?.addEventListener('submit', this.handleSubmit);
        this.restorePin();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
        window.clearTimeout(this.checkTimer);
      }

      handleSubmit = (event) => {
        event.preventDefault();
        const isValidPin = /^\d{6}$/.test(this.input.value.trim());
        this.error.hidden = isValidPin;
        this.result.hidden = !isValidPin;

        if (!isValidPin) {
          this.clearSavedPin();
          this.input.focus();
          return;
        }

        this.savePin(this.input.value.trim());
        this.result.hidden = true;
        this.setLoading(true);
        window.clearTimeout(this.checkTimer);
        this.checkTimer = window.setTimeout(() => {
          this.showEstimate(true);
          this.setLoading(false);
        }, 1000);
      };

      setLoading(isLoading) {
        this.button.disabled = isLoading;
        this.button.setAttribute('aria-busy', String(isLoading));
        this.buttonLabel.textContent = isLoading ? this.dataset.loadingLabel : this.defaultButtonLabel;
      }

      showEstimate(shouldScroll = false) {
        const today = new Date();
        const deliveryStart = this.addDays(today, Number(this.dataset.deliveryDays));
        const deliveryEnd = this.addDays(deliveryStart, Number(this.dataset.deliveryWindow));

        this.error.hidden = true;
        this.result.hidden = false;
        this.querySelector('[data-delivery-date]').textContent = `${this.formatDate(deliveryStart)} to ${this.formatDate(deliveryEnd)}`;

        if (shouldScroll) {
          this.result.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      restorePin() {
        try {
          const savedPin = window.sessionStorage.getItem(this.storageKey);
          if (!/^\d{6}$/.test(savedPin || '')) return;
          this.input.value = savedPin;
          this.showEstimate();
        } catch (_error) {
          // Storage can be unavailable in privacy-restricted browsers.
        }
      }

      savePin(pin) {
        try {
          window.sessionStorage.setItem(this.storageKey, pin);
        } catch (_error) {
          // The estimate still works when storage is unavailable.
        }
      }

      clearSavedPin() {
        try {
          window.sessionStorage.removeItem(this.storageKey);
        } catch (_error) {
          // No action is needed when storage is unavailable.
        }
      }

      get storageKey() {
        return `delivery-pin:${window.location.pathname}:${this.dataset.blockId}`;
      }

      addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

      formatDate(date) {
        return new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN', {
          day: 'numeric',
          month: 'short',
        }).format(date);
      }

      get prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }
  );
}
